export const EmptyValue = (
  param: string | number,
  defaultReturn: string | number = ""
) => {
  return param || defaultReturn;
};
